export default "__VITE_ASSET__MhS$mX6t__"